import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-campagne',
  templateUrl: './list-campagne.component.html',
  styleUrls: ['./list-campagne.component.scss']
})
export class ListCampagneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
